import WorkspaceRedirect from './WorkspaceRedirect';

export default WorkspaceRedirect;
